import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { isNullEmpty } from "../../../utils/validation";
import { getOrderFormShopSummary } from "../../../http/api/MasterAPI";

const OrderFormShopSummarySelect = ({ value, error, onChangeValue }) => {
  const [listOrderFormShopSummarySelect, setListOrderFormShopSummarySelect] = useState([]);
  
  async function getOrderFormShopSummarySelect() {
    try {
      const response = await getOrderFormShopSummary();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          orderFormShopSummaryCd: element.varCd,
          orderFormShopSummaryName: element.varValue1,
        }))
        .filter(
          (x) => x.orderFormShopSummaryName && x.orderFormShopSummaryName.trim() !== ""
        );
      setListOrderFormShopSummarySelect(result);
    } catch (error) {
      console.error("Failed to fetch shop info:", error);
    }
  }

  useEffect(() => {
    getOrderFormShopSummarySelect();
  }, []);

  return (
    <FormControl>
      <Select
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        sx={{ width: 200 }}
        error={!isNullEmpty(error)}
        //onFocus={ () => validate.handleTouch("orderFormShopSummaryCd")}
      >
        {listOrderFormShopSummarySelect.map((item) => (
          <MenuItem
            key={"orderFormShopSummary" + item.orderFormShopSummaryCd}
            value={item.orderFormShopSummaryCd}
          >
            {item.orderFormShopSummaryName}
          </MenuItem>
        ))}
      </Select>
     {!isNullEmpty(error) && (
        <FormHelperText sx={{color:"#d32f2f",marginLeft: 0 }}>{error}</FormHelperText>
      )} 
     </FormControl>
  );
};

export default OrderFormShopSummarySelect;
